import { put, takeEvery } from 'redux-saga/effects';

import { StockAction } from '../actions';
import { StockConstant } from '../constants';

export default function* () {
  yield takeEvery(StockConstant.GET_STOCKS_SUCCESS, getStocksSuccess);
}

function* getStocksSuccess(action) {
  yield put(StockAction.setStocks(action?.payload));
}
